<template>
  <div class="account" v-click-outside="closeOptionList">
    <Avatar @onClick="optionListOpen = !optionListOpen" :border="true" :cursor="true"/>
    <div class="option-list" v-if="optionListOpen && !loading">

      <router-link to="/account">
        <div class="item">Account</div>
      </router-link>

      <div class="item" @click="onTutorials">Tutorials</div>

      <router-link to="/admin" v-if="admin && this.$route.name != 'Admin'">
        <div class="item">Admin Panel</div>
      </router-link>

      <router-link to="/logout">
        <div class="item">Log out</div>
      </router-link>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ClickOutside from 'vue-click-outside'
import { mapActions } from 'vuex'
import Avatar from '@/components/Avatar'

export default {
  name: 'AccountButton',
  data() {
    return {
      optionListOpen: false,
      admin: false,
      loading: true,
      userData: {}
    }
  },
  components: {
    Avatar
  },
  methods: {
    ...mapActions('tutorials', ['openTutorial']),
    closeOptionList() {
      this.optionListOpen = false;
    },
    onTutorials() {
      this.openTutorial();
      this.closeOptionList();
    },
    loadUserData() {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}loadUserData`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        }
      }).then(result => {
        this.userData = result.data.user;
        if(this.userData.specialUser) {
          this.admin = true;
        }
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        console.log(err);
        alert.showError(err);
      })
    },
  },
  directives: {
    ClickOutside
  },
  mounted() {
    this.loadUserData();
  }
}
</script>

<style lang="scss" scoped>
.account {
  width: 2.5rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-right: 2rem;
  @media (max-width: 600px) {
    margin-right: 0.5rem;
  }

  .option-list {
    position: absolute;
    width: 18rem;
    height: auto;
    background-color: white;
    filter:drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.212));
    z-index: 100;
    top: 4.3rem;
    right: 0rem;
    border-radius: 0.2rem;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    a {
      text-decoration: none;
      color: #252629;
    }

    .item {
      width: 100%;
      height: 3rem;
      display: flex;
      align-items: center;
      padding-left: 1rem;
      font-weight: 600;
      transition: 0.2s;
      @media (max-width: 600px) {
        height: 3.5rem;
      }

      &:hover {
        cursor: pointer;
        background-color: #ebc659;
      }
    }
  }
}
</style>